import Router from "next/router";
import { Modal } from "antd";

const UserCenterUtil = (() => {
    const SESSION_STORAGE_KEY = 'userCenterPageKey';
    const BANKACCOUNT_PAGE_NAME = 'bankaccount';

    function goBankAccountPage(){
        let IS_AT_ANYONE_OF_USERCENTER = Router.router.pathname.includes('/cn/usercenter');
        let IS_AT_BANKACCOUNT = IS_AT_ANYONE_OF_USERCENTER && sessionStorage.getItem(SESSION_STORAGE_KEY)===BANKACCOUNT_PAGE_NAME;
        if (IS_AT_BANKACCOUNT) {
            Modal.destroyAll();
            Router.router.reload();
            return;
        }
        //
        sessionStorage.setItem(SESSION_STORAGE_KEY, BANKACCOUNT_PAGE_NAME);
        if (IS_AT_ANYONE_OF_USERCENTER) {
            Router.router.reload();
        } else {
            Router.push('/cn/usercenter');
        }
    }
    return {
        goBankAccountPage
    }
})();
export default UserCenterUtil;
